export default "__VITE_ASSET__WSTm19ia__"